(function($, njm) {
    "use strict";

    njm.views.partnerSearch = Backbone.View.extend({
        events: {
            'keyup .filter-results': 'filter'
        },

        /**
         * Filter
         * @param {Object} e
         */
        filter: function(e) {
            var self = e.currentTarget;
            var search = $(self).val().toLowerCase();

            if (search == "") {
                $(".comp-partners-search .results-container .result").css({
                    display: "inline-block"
                });
            } else {
                $(".comp-partners-search .results-container .result a").each(
                    function() {
                        if ($(this).text().toLowerCase().indexOf(search) >= 0) {
                            $(this).parent(".result").css({ display: "inline-block" });
                        } else {
                            $(this).parent("div").css({ display: "none" });
                        }
                    }
                );

                var resultCount = $(".comp-partners-search div.result").length;
                var resultsHidden = $(
                    '.comp-partners-search div.result[style*="display: none"]'
                ).length;

                if (resultCount === resultsHidden) {
                    $(".comp-partners-search .no-result").css({
                        display: "block"
                    });
                    $(".comp-partners-search .results-container").css({
                        display: "none"
                    });
                } else {
                    $(".comp-partners-search .no-result").css({
                        display: "none"
                    });
                    $(".comp-partners-search .results-container").css({
                        display: "block"
                    });
                }

                console.log(search.length);
            }
        }
    });
})(jQuery, njm);
